import { APIPolicyViolationCondition, EventProps, ExternalProps, Props } from './APIPolicyViolationCondition'
import { AppState, Dispatch } from '../../../../../../../../types'
import { basicAlertModalSelectors } from '../../../../selectors'
import { fetchPolicies } from '../../../../actions'
import { connect } from 'react-redux'

const mapProps = (state: AppState, ownProps: ExternalProps): Props => ({
  ...ownProps,
  policies: basicAlertModalSelectors.policySelector.options(state),
  arePoliciesLoading: basicAlertModalSelectors.policySelector.isFetching(state),
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  fetchPolicies: (orgId, apiId) => dispatch(fetchPolicies(orgId, apiId))
})

export default connect(mapProps, mapDispatch)(APIPolicyViolationCondition)
